import { HTTP } from "../../../services/api-service.js";
import commonObj from "../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;
const labelTemplateCreationStore = {
  namespaced: true,
  state: {
    totalItem: 0,
  },
  actions: {
    getLabelCreationOptionTable({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/labelTemplate/GetLabelCreationOptionTable")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getAllLabelTemplate({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/labelTemplate/GetLabelTemplateHeaders")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getLabelTemplate({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/labelTemplate/GetLabelTemplate", { LblTemplateID: param.LblTemplateID })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    //Post Api
    saveLabelTemplate({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/labelTemplate/SaveLabelTemplate",
          JSON.stringify({
            lblTemplate: param.model,
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteLabelTemplate({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/labelTemplate/DeleteLabelTemplate", { lblTemplateID: param.LblTemplateID })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
  }
};
export default labelTemplateCreationStore;
